import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  result: boolean
  msg: string
}

export const HistoryStatus: React.FC<IProps> = ({ result, msg }) => {
  return (
    <div className='jost-light text-[0.85em] flex items-center justify-start gap-[8px]'>
      {result && (
        <div className='bg-success text-on-success ring-1 ring-success p-[5px] rounded-[12px]'>
          <commonIcons.checkCircle className='text-[1.2em]' />
        </div>
      )}
      {!result && (
        <div className='bg-error text-on-error ring-1 ring-error p-[5px] rounded-[12px]'>
          <commonIcons.toastWarning className='text-[1.2em]' />
        </div>
      )}
      <div>{msg || '*No message provided'}</div>
    </div>
  )
}
